import { render } from "./DrawerLayout.vue?vue&type=template&id=67394b83&ts=true"
import script from "./DrawerLayout.vue?vue&type=script&lang=ts"
export * from "./DrawerLayout.vue?vue&type=script&lang=ts"

import "./DrawerLayout.vue?vue&type=style&index=0&id=67394b83&lang=css"

import exportComponent from "/codebuild/output/src754147292/src/web-ext-galaxycorp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__